<p-panel [toggleable]="true" toggler="header">
  <ng-template #header>
    <app-panel-header titleKey="project.overviewHeader"></app-panel-header>
  </ng-template>
  <ng-template #headericons let-collapsed>
    <i class="pi" [ngClass]="collapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
  </ng-template>

  @if (isLoading()) {
    <app-loading />
  } @else {
    <div class="mb-4 flex justify-end items-center gap-2">
      <app-global-search (searchValue)="searchText.set($event)" />
      <app-dropdown-phase-filter
        [value]="selectedPhase()"
        (valueChange)="selectedPhase.set($event)"
      />
      <app-dropdown-submission-date-filter
        [value]="selectedSubmissionDate()"
        (valueChange)="selectedSubmissionDate.set($event)"
      />
      <app-dropdown-filter
        [options]="sortFieldOptions"
        [value]="sortField()"
        (valueChange)="sortField.set($event)"
        [showDirection]="true"
        [direction]="sortDirection()"
        (directionChange)="sortDirection.set($event)"
      />
    </div>
    <div class="flex flex-col gap-4">
      @for (project of sortedProjects(); track project.projectId) {
        <div class="bg-second-level rounded-lg p-4">
          <div class="flex items-center gap-4 flex-wrap mb-4">
            <span class="flex items-center gap-1 opacity-80">
              <i class="pi pi-building"></i>{{ project.tenantName }}
            </span>
            <span class="flex items-center gap-1 font-bold text-lg">{{ project.projectName }}</span>
            <span class="flex items-center gap-1 text-sm opacity-70">
              <i class="pi pi-clock text-blue"></i>{{ project.beginDate | appDate }}
            </span>
            <span class="flex items-center gap-1 text-sm opacity-70">
              <i class="pi pi-flag text-green"></i>{{ project.endDate | appDate }}
            </span>
          </div>
          <app-chapter-progress-grid [chapterMetrics]="project.chapterMetrics" />

          <app-phase-status-bars [phaseStatusInfos]="project.phaseStatusInfos" />
        </div>
      }
    </div>
  }
</p-panel>
